import { masterdataEditComponent } from './masterdata.edit.component';
import { masterdataListComponent } from './masterdata.list.component';
import { masterdataComponent } from './masterdata.component';
import { MasterdataRestService } from './services/masterdata.service';
import { masterdataListEditState, masterdataListState, masterdataState } from './masterdata.states';
import { MasterdataService } from './masterdata.provider';
import { loadNg1Module, ngmodule } from "./bootstrap/ngmodule";

import 'angular-ui-router-uib-modal';

const crmAppModule = {
    components: {
       masterdataComponent,
       masterdataListComponent,
       masterdataEditComponent
    },
    states: [
        masterdataState,
        masterdataListState,
        masterdataListEditState
    ],
    services: {
        MasterdataRestService
    },
    providers: {
        MasterdataService
    },
    directives : {
       
    }
};

loadNg1Module(ngmodule, crmAppModule);


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/index.ts